class PhotoTestimonialsCarousel extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-photo-testimonials-track]');
    this.prevButton = this.querySelector('.photo-testimonials__arrow--prev');
    this.nextButton = this.querySelector('.photo-testimonials__arrow--next');
    this.speed = parseInt(this.dataset.speed, 10) || 5000;

    const originalSlides = this.track ? Array.from(this.track.children) : [];
    this.slideCount = originalSlides.length;
    if (!this.track || this.slideCount < 2) return;

    // Carrusel infinito: se clona el set completo de fotos antes y
    // después del real, así siempre hay contenido de sobra para
    // desplazarse en cualquier dirección. Al llegar a una foto clonada,
    // saltamos (sin animación, invisible al ojo) a la foto real
    // equivalente — nunca se ve el "corte" ni un rebote hacia atrás.
    const cloneSet = () =>
      originalSlides.map((slide) => {
        const clone = slide.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.removeAttribute('data-shopify-editor-block');
        return clone;
      });

    cloneSet()
      .reverse()
      .forEach((clone) => this.track.insertBefore(clone, this.track.firstChild));
    cloneSet().forEach((clone) => this.track.appendChild(clone));

    // Arranca posicionado justo al inicio del bloque real (después del
    // primer set clonado), sin animación.
    const slides = Array.from(this.track.children);
    this.track.scrollLeft = slides[this.slideCount].offsetLeft;

    this.prevButton?.addEventListener('click', () => {
      this.stop();
      this.advance(-1);
      this.play();
    });
    this.nextButton?.addEventListener('click', () => {
      this.stop();
      this.advance(1);
      this.play();
    });

    this.addEventListener('mouseenter', () => this.stop());
    this.addEventListener('mouseleave', () => this.play());
    this.addEventListener('focusin', () => this.stop());
    this.addEventListener('focusout', () => this.play());

    this.play();
  }

  getCurrentIndex() {
    const slides = Array.from(this.track.children);
    return slides.reduce((closest, slide, index) => {
      const closestDistance = Math.abs(slides[closest].offsetLeft - this.track.scrollLeft);
      const distance = Math.abs(slide.offsetLeft - this.track.scrollLeft);
      return distance < closestDistance ? index : closest;
    }, 0);
  }

  advance(direction = 1) {
    const track = this.track;
    const slides = Array.from(track.children);
    if (!slides.length) return;

    const currentIndex = this.getCurrentIndex();
    const nextIndex = currentIndex + direction;
    if (nextIndex < 0 || nextIndex >= slides.length) return;

    track.scrollTo({ left: slides[nextIndex].offsetLeft, behavior: 'smooth' });

    // Después de que termine la animación, si quedamos sobre una foto
    // clonada, saltamos a la real equivalente al otro extremo del set.
    clearTimeout(this._loopTimeout);
    this._loopTimeout = setTimeout(() => this.normalizePosition(nextIndex), 600);
  }

  normalizePosition(index) {
    const track = this.track;
    const slides = Array.from(track.children);
    const total = this.slideCount;

    if (index < total) {
      track.scrollLeft = slides[index + total].offsetLeft;
    } else if (index >= total * 2) {
      track.scrollLeft = slides[index - total].offsetLeft;
    }
  }

  play() {
    clearInterval(this.timer);
    this.timer = setInterval(() => this.advance(1), this.speed);
  }

  stop() {
    clearInterval(this.timer);
  }

  disconnectedCallback() {
    clearInterval(this.timer);
    clearTimeout(this._loopTimeout);
  }
}

customElements.define('photo-testimonials-carousel', PhotoTestimonialsCarousel);
